"use client";

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/utils";

const switchVariants = cva(
    "focus-visible:ring-offset-white peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-stroke-transparent transition-colors focus:rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-background-success-secondary data-[state=unchecked]:bg-background-tertiary",
    {
        variants: {
            size: {
                default: "h-6 w-11",
                lg: "h-8 w-14"
            }
        },
        defaultVariants: {
            size: "default"
        }
    }
);

const thumbVariants = cva("pointer-events-none block rounded-full bg-background-primary shadow-lg ring-0 transition-transform", {
    variants: {
        size: {
            default: "size-5 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
            lg: "size-6 data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-0"
        }
    },
    defaultVariants: {
        size: "default"
    }
});

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>, VariantProps<typeof switchVariants> {}

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(({ className, size, ...props }, ref) => (
    <SwitchPrimitives.Root className={cn(switchVariants({ size }), className)} {...props} ref={ref}>
        <SwitchPrimitives.Thumb className={cn(thumbVariants({ size }))} />
    </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch, switchVariants };
